import React, { useState } from 'react';
import styles from './Header.module.scss';
import Logo from './Logo/Logo';
import Menu from './Menu/Menu';
import MenuMobile from './Menu/MenuMobile';
import { useMediaQuery } from 'react-responsive';

const Header = () => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const isMobile = useMediaQuery( {query: '(max-width: 1024px)' });

    const menuHandler = () => {
        if(isMenuOpen) {
            setIsMenuOpen(false)
        } else {
            setIsMenuOpen(true);
        }   
    }

    return (
        <header id={styles.header}>
            <Logo />
            <Menu menuHandler={menuHandler} />
            {isMobile && <MenuMobile isMenuOpen={isMenuOpen} menuHandler={menuHandler} />} 
        </header>
    );
}

export default Header;
